import React from "react";
import { Form } from "@redriver/cinnamon";
import { getDepartments } from "./actions";

const DepartmentsTypeAhead = (props) => (
  <Form.TypeAhead {...props} lookupAction={getDepartments} />
);

export default DepartmentsTypeAhead;
